import "./public.scss";
import { Outlet } from "react-router-dom";
import FooterComponent from "src/components/footer";
import ScrollToTopComponent from "src/components/scroll-to-top";
import HeaderResaleComponent from "src/components/header-resale";

function PublicResaleLayout() {
  return (
    <div className="PublicResaleLayoutStyle">
      <HeaderResaleComponent isTopPage={true} />
      <Outlet />
      <FooterComponent isResale={true} />
      <ScrollToTopComponent />
    </div>
  );
}

export default PublicResaleLayout;
